import { v4 as uuidv4 } from 'uuid'
import { SampleCustom, SampleDataField } from './SampleCustom'

export interface SampleCustomDTO {
  _id: string | undefined
  _typeSample: string
  _sampleData: SampleDataField[]
}

export function emptySampleCustomDTO(): SampleCustomDTO {
  return {
    _id: uuidv4(),
    _typeSample: '',
    _sampleData: [],
  }
}

export function fromSampleCustomModel(c: SampleCustom): SampleCustomDTO {
  return {
    _id: c.id,
    _typeSample: c.typeSample,
    _sampleData: c.sampleData,
  }
}

export function toModelSampleCustom(c: SampleCustomDTO): SampleCustom {
  return new SampleCustom(c)
}
